import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const SettingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-family: 'Montserrat', sans-serif;
`;

export const SettingHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

export const SettingTitle = styled.span`
  color: ${themeGet('colors.black.100')};
  font-size: 20px;
  font-weight: 600;
`;

export const SettingCreate = styled.span`
  color: ${themeGet('colors.primary.100')};
  font-size: 12px;
  font-weight: 600;
  padding-top: 10px;
  cursor: pointer;
  &:hover {
    color: ${themeGet('colors.primary.80')};
  }
  &:active {
    color: ${themeGet('colors.primary.120')};
  }
`;

export const SettingItemsWrapper = styled.div`
  margin-bottom: 16px;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormTitle = styled.span`
  font-family: 'Montserrat', sans-serif;
  color: ${themeGet('colors.black.100')};
  font-size: 20px;
  font-weight: 600;
  align-self: start;
  margin-bottom: 16px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  align-self: flex-end;
  margin: 16px 0 0;
`;

export const FormContainer = styled.div`
  text-align: justify;
`;

export const Label = styled.label`
  width: 385px;
  height: 26px;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #636363;
  margin-bottom: 0;
`;

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  margin-top: 16px;

  .audience-filter {
    width: 100%;
  }

  .react-select__control {
    border: 1px solid ${themeGet('colors.black.20')} !important;
  }

  .react-select__input {
    input {
      margin: 0 !important;
    }
  }

  .react-select__placeholder {
    color: ${themeGet('colors.black.20')};
  }
`;

export const ColorOption = styled.div`
  cursor: pointer;
  height: 24px;
  width: 24px;
  border-radius: 4px;
  background: ${props => props.background};
  position: relative;

  &:after {
    content: '${props => (props.isSelected ? '\\2713' : '')}';
    font-size: 25px;
    position: absolute;
    color: white;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const ColorPickerInput = styled.input`
  cursor: pointer;
  display: inline-block !important;
  float: left;
  height: 34px !important;
  margin-bottom: 5px !important;
  margin-right: 10px !important;
  margin-top: 0 !important;
  margin: 0;
  padding: 0 !important;
  width: 34px !important;
`;

export const ColorPickerContainer = styled.div`
  margin-top: 15px;
`;

export const StyledItem = styled.li`
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 8px 8px 16px;
  border: solid 1px;
  border-radius: 8px;
  margin-bottom: 8px;
  border-color: ${themeGet('colors.black.20')};
`;

export const Info = styled.div`
  display: flex;
  align-items: center;
`;

export const ColorCircle = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 100%;
  margin-right: 8px;
  background-color: ${props => props.color};
`;

export const ButtonsWrapper = styled.div`
  display: flex;
`;

export const SquareButton = styled.div`
  display: flex;
  justify-content: center;
  border-radius: 6px;
  border: 0.375px solid ${themeGet('colors.black.40')};
  padding: 4px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  & + div {
    margin-left: 5px;
  }
`;

export const SettingsList = styled.ul`
  margin-top: 20px;
  font-size: 18px;
  max-height: 262px;
  overflow-y: scroll;
`;

export const DeleteContent = styled.div`
  text-align: justify;
  line-height: 1.3em;
`;

export const SettingItemIcon = styled.i`
  color: ${themeGet('colors.black.50')};
`;
